import { Head } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Manage", href: "/admin/retention" },
  { title: "2-Year Data Purge", href: "/admin/cron/2y" },
]

interface PurgeResult {
  cases_found: number
  documents_purged: number
  subject_photos_purged: number
  subjects_purged: number
  log_entries: string[]
}

interface Props {
  result: PurgeResult
}

export default function TwoYear({ result }: Props) {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="2-Year Data Purge" />

      <div className="p-6">
        <h1 className="border-hpi-light-gray mb-6 border-b pb-2 text-2xl font-semibold">
          2-Year Data Purge Results
        </h1>

        <div className="mb-6 grid grid-cols-2 gap-4 md:grid-cols-4">
          <StatCard label="Cases Found" value={result.cases_found} />
          <StatCard label="Documents Purged" value={result.documents_purged} />
          <StatCard
            label="Subject Photos Purged"
            value={result.subject_photos_purged}
          />
          <StatCard label="Subjects Purged" value={result.subjects_purged} />
        </div>

        {result.log_entries.length > 0 ? (
          <div>
            <h2 className="mb-2 text-lg font-semibold">Purge Log</h2>
            <pre className="max-h-96 overflow-y-auto rounded bg-gray-50 p-4 text-sm text-gray-700">
              {result.log_entries.join("\n")}
            </pre>
          </div>
        ) : (
          <p className="text-gray-500">
            No records were eligible for purging in this run.
          </p>
        )}

        <p className="mt-4 text-sm text-gray-500">
          An email log has been sent to administrators.
        </p>
      </div>
    </AppLayout>
  )
}

function StatCard({ label, value }: { label: string; value: number }) {
  return (
    <div className="rounded-lg border bg-white p-4 shadow-sm">
      <dt className="text-sm font-medium text-gray-500">{label}</dt>
      <dd className="mt-1 text-2xl font-semibold">{value}</dd>
    </div>
  )
}
